/* eslint-disable no-undef */
import { memo, useEffect } from 'react'
import { CssBaseline, ThemeProvider } from '@mui/material'

import {
  RegisteredEventName,
  broadcastToParent,
} from '@finanzcheck/catalyst-pollard'

import SmavaLandingPage from '../../../components/page/SmavaLandingPage'
import FinanzcheckLandingPage from '../../../components/page/FinanzcheckLandingPage'

import theme, { SupportedTheme } from '../../../theme'
import { isSmava } from '../../../utils/getTenantInfo.utils'
import { initPollardCommunication } from '../../../utils/pollard'
import { customizeTheme } from '../../../utils/theme.utils'
import useUrlParams from '../../../hooks/useUrlParams'
import { getAdvertisementId, getRefId } from '../../../utils/url'
import { getSessionId } from '../../../utils/session.utils'

const Base = () => {
  const queryParams = useUrlParams()
  const advertisementId = getAdvertisementId(queryParams)
  const refId = getRefId(queryParams)

  customizeTheme(SupportedTheme.Embedded, queryParams)

  useEffect(() => {
    initPollardCommunication()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    broadcastToParent({
      eventName: RegisteredEventName.tracking,
      data: {
        event: '/affiliate:visit',
        fcId: getSessionId(),
        ...queryParams,
        advertisementId,
        refId,
        src: 'antrag',
      },
    })
  }, [])

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {isSmava ? (
        <SmavaLandingPage
          hasHeader={false}
          hasEkomi={false}
          hasGuenstigerGehtNicht={false}
          extendedFooter={false}
          hasTuev={false}
        />
      ) : (
        <FinanzcheckLandingPage
          hasHeader={false}
          hasTuev={false}
          extendedFooter={false}
        />
      )}
    </ThemeProvider>
  )
}

export default memo(Base)
